import { utils, config } from '@/lib';
import isEmpty from 'lodash/isEmpty';

const Sidebar = (props) => {
  const { data } = props;
  const posters = isEmpty(data.poster) ? [] : data.poster;
  const notices = data.notice || [];
  return (
    <div className="sidebar-wrap">
      <div className="activity-sec">
        <div className="sec-header">
          <i className="icon-index icon-index-activity"></i>
          <div className="sec-label">活动中心</div>
        </div>
        <div className="sidebar-common-wrap">
          {posters.map((poster) => {
            return (
              <a
                className="poster"
                href={poster.click_url}
                target="_blank"
                data-sawebclick="id=001t05n001"
              >
                <img
                  className="lazyimg"
                  src={config.defaultImg}
                  data-original={poster.pic_url}
                  alt={poster.title}
                />
              </a>
            );
          })}
        </div>
      </div>
      {/*公告帮助*/}
      <div className="notice-sec">
        <div className="sec-header">
          <i className="icon-index icon-index-notice"></i>
          <div className="sec-label">公告帮助</div>
          <a
            href="/help/7"
            className="more-link"
            target="_blank"
            data-sawebclick="id=001t06b002"
          >
            查看全部
          </a>
        </div>
        <div className="sidebar-common-wrap">
          {notices.map((notice) => {
            return (
              <a
                key={notice._id}
                href={`/notice/${notice._id}`}
                className="notice clearfix"
                target="_blank"
                data-sawebclick="id=001t06b001"
              >
                <i className={`notice-label notice-label-${notice.type}`}>
                  {{ 0: '公告', 1: '帮助', 7: '规则', 8: '活动' }[
                    notice.type
                  ] || ''}
                </i>
                <span className="notice-title text-overflow">
                  {notice.title}
                </span>
                <span className="notice-date">
                  {utils.formatTime(notice.timestamp, 'MM/dd')}
                </span>
              </a>
            );
          })}
        </div>
      </div>
      <div id="sidebar-ranks"></div>
    </div>
  );
};

export default Sidebar;
